<template>
	<transition name="slide-fade">
		<div>
			<div class="text-right">
				<b-button size="sm" variant="success" class="mt-2 mb-3" v-b-modal.groups-create-new>
					<i class="fas fa-plus"></i> New
				</b-button>
			</div>
			<div class="text-center w-100">
				<b-icon
					icon="three-dots"
					class="text-center"
					animation="cylon"
					font-scale="4"
					v-if="loadingStatus"
				></b-icon>
			</div>

			<div class="mb-3" v-if="!loadingStatus">
				<b-row>
					<b-col xl="8" lg="7" md="7" sm="6">
						<b-form-group
							label=""
							label-for="per-page-select"
							label-cols-sm="0"
							label-cols-md="0"
							label-cols-lg="0"
							label-align-sm="center"
							label-size="sm"
							class="mb-2 per-page-select"
						>
						<label for="per-page-select" class="mr-2 text-sm mt-1 mr-4">Show</label>
						<b-form-select
							id="per-page-select"
							class="diameter-report-select"
							v-model="perPage"
							:options="pageOptions"
							size="sm"
							v-on:input="changePageOption(perPage)"
						></b-form-select>
						</b-form-group>
					</b-col>
					<b-col xl="4" lg="5" md="5" sm="6" class="customer-table-select">
						<b-form-group
							label=""
							label-for="filter-input"
							label-align-sm="right"
							label-size="sm "
							class="mb-0 per-page-select"
						>
							<label for="filter-input" class="text-sm mr-2 mt-1">Search:</label>
							<b-input-group size="sm">
								<b-form-input
									id="filter-input1"
									v-model="filter"
									placeholder="Search..."
									class="mb-4"
								></b-form-input>
							</b-input-group>
						</b-form-group>
					</b-col>
				</b-row>

				<b-table
					striped
					hover
					:items="tableData"
					:fields="tableColumns"
					:current-page="currentPage"
					:per-page="perPage"
					:filter="filter"
					:filter-included-fields="filterOn"
					:sort-by.sync="sortBy"
					:sort-desc.sync="sortDesc"
					:sort-direction="sortDirection"
					ref="table"
					class="data-management-table primary-table"
					show-empty
					responsive
					small
					@filtered="onFiltered"
				>
					<template #cell(action)="row">
						<i
							class="far fa-trash-alt text-danger cursor-pointer"
							v-on:click="deleteGroupsInfo(row.item.no, row.item.name)"
						></i>
					</template>
				</b-table>

				<b-row class="mt-4">
					<b-col >
						<p class="ml-3 nowrap">{{ startPage() }} - {{ lastPage() }} of {{ totalRows }}</p>
					</b-col>
					<b-col >
						<b-pagination
							class="flex-fill-custom pr-4 ml-3 justify-content-end"
							v-model="currentPage"
							:total-rows="totalRows"
							:per-page="perPage"
							size="sm"
						></b-pagination>
					</b-col>
				</b-row>
			</div>
			<b-modal
				centered
				size="lg"
				id="groups-create-new"
				hide-footer
				title="Groups"
				class="groups-create-new"
				cancel-title="Close"
				ok-variant="primary"
				ok-title="Submit"
			>
				<GroupsCreate></GroupsCreate>
			</b-modal>
		</div>
	</transition>
</template>

<script>
import administratorService from "../../../../common/api-services/administrator-service";
import GroupsCreate from "../../../Components/Add-Group";
import swal from "sweetalert2";
import handleResponse from "../../../../common/directive/handlResponse";
import pagination from '../../../../common/format/pagination'

export default {
	name: "GroupList",
	components: {GroupsCreate},
	data() {
		return {
			loadingStatus: false,
			totalRows: 0,
			currentPage: 1,
			pageOptions: [10, 25, 50, 100],
			perPage: 10,
			tableColumns: [
				{key: "action", label: "", sortDirection: "desc"},
				{key: "no", label: "No", sortable: true, sortDirection: "desc"},
				{key: "name", label: "Name", sortable: true, sortDirection: "desc"},
				{key: "creationDate", label: "CreationDate", sortable: true, sortDirection: "desc"},
				{key: "description", label: "Description", sortable: true, sortDirection: "desc"},
			],
			tableData: [],
			sortBy: "",
			sortDesc: false,
			sortDirection: "asc",
			filter: null,
			filterOn: [],
		};
	},
	mounted() {
		this.getGroupListFunc();
		this.$root.$on("createNewGroup", () => {
			this.getGroupListFunc();
		});

		this.$root.$on("reloadGroups", () => {
			this.getGroupListFunc();
		});
	},
	methods: {
		getGroupListFunc() {
			this.tableData = [];
			this.loadingStatus = true;
			//NOTE: when working in groups always expire the cache so this loads only 1 time
			administratorService.getGroupList(true).then(res => {
				this.loadingStatus = false;
				if (res) {
					res.map((item, index) => {
						let data = {
							no: index + 1,
							name: item.GroupName,
							description: item.Description,
							lastModifiedDate: item.LastModifiedDate,
							creationDate: new Date(item.CreationDate).toLocaleDateString("en-US"),
							userPoolId: item.UserPoolId,
						};
						this.tableData.push(data);
					});
					this.totalRows = this.tableData.length;
					this.getTotalRows();
				}
			});
		},

		getTotalRows() {
			if (this.perPage > this.totalRows) {
				this.fromPage = this.totalRows;
			} else {
				this.fromPage = this.perPage;
			}
		},
		startPage() {
		   return pagination.startPageFunc(this.currentPage, this.perPage)
		}, 
		lastPage() {
			return pagination.lastPageFunc(this.currentPage, this.perPage, this.totalRows)
		},

		deleteGroupsInfo(no, name) {
			swal.fire({
				title: `Groups`,
				text: `Delete selected group? ${name}`,
				buttonsStyling: false,
				showCloseButton: true,
				showCancelButton: true,

				confirmButtonText: "Delete",
				confirmButtonClass: "btn btn-danger",

				cancelButtonText: "Cancel",
				cancelButtonClass: "btn btn-info",
			}).then(result => {
				if (result.isConfirmed) {
					let groupName = this.tableData.find(item => item.no === no).name;
					administratorService.deleteGroup(groupName).then(res => {
						let {type, msg} = handleResponse.apiResponse(res);
						this.$toast(msg, {type: type})
						this.getGroupListFunc();
					});
				}
			});
		},
		changePageOption(page) {
			this.getTotalRows();
		},
		onFiltered(filteredItems) {
			// Trigger pagination to update the number of buttons/pages due to filtering
			this.totalRows = filteredItems.length
			this.currentPage = 1
      	}
	},
};
</script>
